import React from 'react';
import { DSBadge } from '../design-system/primitives';

// Thin wrapper over DSBadge, kept so the 79 existing call sites across 33 files keep
// working unchanged. Its variant, size and uppercase props map straight onto the
// design system's, and its own stylesheet is gone - the visuals now come from tokens.
//
// New code should import DSBadge directly.
// `leadingIcon` is forwarded, not dropped. It is DSBadge's icon slot, and the slot is
// what sizes the glyph to the badge's own font: an icon passed as a child instead keeps
// DSIcon's 20px default, about twice the height of a badge label.
function StatusBadge({ label, children, variant = 'neutral', size = 'md',
                       uppercase = false, leadingIcon, className = '' }) {
  const content = label ?? children;

  // Existing behaviour worth preserving: an empty status renders nothing at all,
  // rather than an empty pill.
  if (content === undefined || content === null || content === '') {
    return null;
  }

  return (
    <DSBadge variant={variant} size={size} uppercase={uppercase}
             leadingIcon={leadingIcon} className={className}>
      {content}
    </DSBadge>
  );
}

export default StatusBadge;
